import { RETAILER_PROFILE, RETAILER_PUBLIC_CONNECTION } from 'routes/paths'

import { Feature, UserTypeSelector } from '../earlyAccessWidget.types'
import { getRetailerFeatureLink } from '../utils/featureLinks.utils'

export const UNSUBSCRIBE_MANAGE_STYLES_PENDO_ID = 'o2R1JesAgSSmiyXwmn7Tcq1t0OQ'
export const UNSUBSCRIBE_RETAILER_PROFILE_PENDO_ID =
  'cv7C_3F27qwYDFLtghTADb2zw8s'

export const FEATURES: Feature[] = [
  {
    earlyAccessAdminFlag: 'early-access-bulk-image-uploader-admin',
    earlyAccessFeatureFlag: 'early-access-bulk-image-uploader',
    title: () => 'New Image Uploader',
    description: () =>
      `Explore the new Image Upload experience, now available for early access.<br><br>
      During preview period, you can turn it on or off at any time. This feature will be automatically enabled for your account on <b>October 15, 2025.</b>`,
    userTypeSpecific: [UserTypeSelector.isLiteBrand],
    widgetConfigs: [
      {
        urlRegexp: /^\/accounts\/home$/gim,
        pushContent: false,
      },
    ],
    isFeedbackHidden: true,
  },
  {
    earlyAccessFeatureFlag: 'retailer-profile-brand-visibility',
    title: () => 'New Retailer Profile!',
    description: () =>
      'Discover our updated Retailer Profiles with a cleaner format and larger store images to help you easily evaluate potential retailers. Try it now and share your feedback before it goes live in July. Navigate to a Retailer Profile to see the update!',
    earlyAccessAdminFlag: 'early-access-retailer-profile-migration',
    feedbackButtonId: 'early-access__lead-gen__retailer-profile-visibility',
    unsubscribePendoGuideId: UNSUBSCRIBE_RETAILER_PROFILE_PENDO_ID,
    userTypeSpecific: [
      UserTypeSelector.isProBrand,
      UserTypeSelector.isLiteBrand,
    ],
    oldFeatureLink: () =>
      getRetailerFeatureLink(
        /^\/ra\/profile\/\d+$/i,
        RETAILER_PUBLIC_CONNECTION,
      ),
    newFeatureLink: () =>
      getRetailerFeatureLink(
        /^\/boutiques\/view\/\d+$/gim,
        RETAILER_PROFILE.replace('/:accountId', ''),
      ),
    widgetConfigs: [
      {
        urlRegexp: /^\/Accounts\/home$/gim,
        pushContent: false,
      },
      {
        urlRegexp: /^\/ra\/profile\/\d+$/gim,
        pushContent: false,
      },
      {
        urlRegexp: /^\/boutiques\/view\/\d+$/gim,
        pushContent: false,
      },
    ],
  },
]

export const FEATURE_COUNT_BADGE_COOKIE = 'early-access-badge'
export const FEATURE_COUNT_BADGE_VALUE = 'viewed'
export const FEATURE_COUNT_DEFAULT_VALUE = 0
export const RATE_LIMIT_ERROR_CODE = 'API_ERROR'
export const RATE_LIMIT_ERROR_MESSAGE = 'LaunchDarkly API rate limit reached'
export const CAPACITY_LIMIT_ERROR_CODE = 'FAILED_PRECONDITION'
export const CAPACITY_LIMIT_WAIT_LIST =
  'https://docs.google.com/forms/d/e/1FAIpQLSeQt6floCX54f2R_m40qFiyCs1ZE7Xrfzn6pb5XDcbG6XKlfA/viewform'

export const ERROR_MAX_CAPACITY_TOAST_CONTENT = {
  title: 'The beta is full',
  description: 'We’ve reached capacity for users to test this feature.',
  shouldCloseManually: true,
  action: {
    label: 'Click here to join the waitlist',
    handler: () => {
      window.open(CAPACITY_LIMIT_WAIT_LIST, '_blank')
    },
  },
  className: 'font-size-fix',
}
